import React, { useState, useEffect } from 'react';


function SaleClock() {
    const [date, setDate] = useState(new Date());

    useEffect(() => {
        const timerID = setInterval(() => tick(), 1000);

        return function cleanup() {
            clearInterval(timerID);
        };
    });

    function tick() {
        setDate(new Date());
    }

    const dateString = `${date.getDate()}-${date.toLocaleDateString(undefined, { month: 'short' })}-${date.getFullYear()} ${date.toLocaleTimeString()}`;

    return (
        <>
            {dateString}
        </>
    );
}

export default SaleClock;